import Grid from '@material-ui/core/Grid';
import React from 'react';
import Typography from '@material-ui/core/Typography';

const CollectionItemHeader = (props) => {
  return (
    <Grid container direction='row' justify='space-between' alignItems='flex-start'>
      <Grid item>
        <Grid container direction='column' alignItems='center'>
          <Grid item>
            <Typography variant='h5' noWrap>
              {props.title}
            </Typography>
            <Typography variant='subtitle2' noWrap>
              {props.subtitle}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={ 8 }>
        <Grid container direction='row' justify='space-between' alignItems='flex-start'>
          {props.actions}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CollectionItemHeader;
